import '@/svgsprite'
import { OccContext } from '@omnia/ui/src/lib/cms/core-components/occConfiguration/OccContextComponent'
import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import { PagesRouter } from '@omnia/ui/src/lib/routing/PagesRouter'
import { sanitizeSiteTitle } from '@omnia/ui/src/lib/utils/strings/sanitizeSiteTitle'
import { defaultOccAssets } from '@vista-digital/occ-ui'
import { type FunctionComponent, useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { changeOccContextDisplayText } from '@/common/occ-utils/changeOccContextDisplayText'
import { cmsDataService } from './common/services/cms.data.service'
import { Layout } from './features/layout/Layout'
import { getCustomOccConfig } from '@/common/occ-utils/getCustomOccConfig'

interface AppOverrideProps {
    pagesRouterOverride?: FunctionComponent
}

export const App: FunctionComponent<AppOverrideProps> = props => {
    const logger = useLogger('App')
    logger.info('App rendering', { loadTime: Date.now() - window.loadMs, version: APP_VERSION })

    const PagesRouterElement = useMemo(() => props.pagesRouterOverride ?? PagesRouter, [props.pagesRouterOverride])
    const occConfig = useMemo(() => getCustomOccConfig(), [])

    defaultOccAssets['carouselNextButtonIconName'] = 'arrow-right'
    defaultOccAssets['carouselPreviousButtonIconName'] = 'arrow-left'

    return (
        <OccContext changeOccContextDisplayText={changeOccContextDisplayText} config={occConfig}>
            <Helmet>
                <title>{sanitizeSiteTitle(cmsDataService.get().siteTitle)}</title>
            </Helmet>
            <PagesRouterElement Layout={Layout} />
        </OccContext>
    )
}
